import {
  IRequestAdminTableHistoricoIperc,
  IRequestTableHistoricoIPERC,
} from "../../Interfaces/IIpercBase";
import { _formatDate } from "../helpers/dateHelpers";

export const InitialRequestTableHistoricoIPERC: IRequestTableHistoricoIPERC = {
  actividadId: null,
  equipoId: null,
  fechaFin: "",
  estadoId: null,
  fechaInicio: "",
  skip: 0,
  take: 50,
  search: "",
};

export const InitialRequestAdminHistoricoIperc: IRequestAdminTableHistoricoIperc =
  {
    actividadId: null,
    equipoId: null,
    supervisorId: null,
    guardia: null,
    fechaFin: _formatDate(new Date(), ","),
    estadoId: null,
    fechaInicio: _formatDate(new Date(), ","),
    skip: 0,
    take: 50,
    search: "",
  };
